<template>
  <!-- -->
  <div class="defaultViewStyle">
<!--    <page-header>-->
<!--      <template #content>-->

<!--      </template>-->
<!--    </page-header>-->

    <tx-map map-id="stockMap" :other-show="true" ref="txMapRef" :show-column="'stockName'" :lat-lng-list="getLatLntStockList" @click-marker="markClick">
      <template #other-show>
        <el-tree
            style="height: 100%; overflow: scroll"
            :data="departList"
            :props="{  children: 'children', label: 'departName', }"
            @node-click="handleNodeClick"
        >
          <template #default="{node, data}">
            <el-tooltip effect="light" placement="right" :content="data.stockAddress" v-if="data.stockName">
              {{data.stockName}}
            </el-tooltip>
            <span v-else>{{data.departName}}</span>
          </template>
        </el-tree>
      </template>
    </tx-map>
    <!-- 地图信息 -->
<!--    <tlbs-map-->
<!--        style="width: 400px; height: 400px"-->
<!--        v-if="showMap"-->
<!--        ref="mapRef"-->
<!--        api-key="2PTBZ-6VF6Q-66S5A-2SFTC-YBCTO-56BD6"-->
<!--        :center="center"-->
<!--        :zoom="zoom"-->
<!--        :control="control"-->
<!--        @click="getMarkerFromMap"-->
<!--        @map_inited="onMapInited"-->
<!--    >-->
<!--      <div class="show-stock">-->
<!--        <el-dropdown trigger="hover">-->
<!--          <div>-->
<!--            <el-icon style="font-size: 24px;margin-top: 2px">-->
<!--              <Operation/>-->
<!--            </el-icon>-->
<!--          </div>-->

<!--          <template #dropdown>-->
<!--            <el-dropdown-menu>-->
<!--              <el-dropdown-item v-for="it in stockList" :key="it.id" @click="center = {lat: it.lat, lng: it.lng}">-->
<!--                {{ it.stockName }}-->
<!--              </el-dropdown-item>-->
<!--            </el-dropdown-menu>-->
<!--          </template>-->
<!--        </el-dropdown>-->
<!--      </div>-->

<!--      <tlbs-multi-marker-->
<!--          @click="markClick($event)"-->
<!--          ref="markerRef"-->
<!--          :geometries="geometries"-->
<!--          :styles="styles"-->
<!--          :options="options"-->
<!--      />-->
<!--    </tlbs-map>-->


    <el-drawer v-model="showDrawer" direction="rtl">
      <template #header>
        <span style="font-size: 20px; color: black">{{ currentData.stockName }}</span>
      </template>
      <template #default>
        <div style="height: 96%">
          <table-list style="height: 100%">
            <el-table ref="tableRef" stripe :data="currentData.productList" height="100%">
              <el-table-column align="center" width="60px" type="selection"/>
              <el-table-column align="center" label="商品名称" prop="skuName"/>
              <el-table-column align="center" label="库存数量" prop="stockQty"/>
            </el-table>
          </table-list>
        </div>
        <form-page v-model:page-number="searchParams.pageNumber" v-model:page-size="searchParams.pageSize"
                   :total-count="searchParams.totalCount" @onLoad="queryList"/>
      </template>
      <template #footer>
        <div style="flex: auto">
          <el-button type="primary" @click="toReceipt">快速领用</el-button>
        </div>
      </template>
    </el-drawer>
  </div>

</template>

<script setup>
import {getCurrentInstance, onMounted, ref, computed} from "vue"
import commonApi from "@/api/commonApi";
import TxMap from "@/components/h5/map/TxMap.vue";
import stockApi from "@/api/main/stock/stockApi";
import TableList from "@/components/h5/layout/TableList.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";

const {proxy} = getCurrentInstance()

const apiKey = ref("")
const currentStockId = ref("")
const showMap = ref(false)
const stockList = ref([])
const departList = ref([])
const showDrawer = ref(false)

const currentData = ref({})

const handleStockAndDept = ref([])

const txMapRef = ref()

const getLatLntStockList = computed(() => {
  return stockList.value.filter(
      it =>
        it.lat && it.lng
  )
})

const handleNodeClick = (data) => {
  if (!data.stockName) {
    return
  }
  if (!data.lat || !data.lng) {
    proxy.$message.error("请先添加仓库标点信息！")
    return
  }

  const obj = {
    latLng: {
      lat: data.lat,
      lng: data.lng,
      height: 0
    },
    geometry: {
      data: data,
      position: {
        lat: data.lat,
        lng: data.lng,
        height: 0
      },
      title: data.stockName
    }
  }
  txMapRef.value.mapMarkerClick2(obj)
}

// 初始化所有仓库信息
const initStockList = async () => {
  stockList.value = await commonApi.queryAllStock()
  departList.value = await commonApi.queryDepart()
  handleDeptAndStock()
}

const handleDeptAndStock = () => {
  departList.value.forEach(item => {
    let arr = []
    for (let i = 0; i < stockList.value.length; i++) {
      const stock = stockList.value[i]
      if (stock.bankupId === item.id) {
        arr.push({
          ...stock,
          departName: stock.stockName,
        })
      }
    }
    item.children = arr
  })
  departList.value = departList.value.filter(item => item.children && item.children.length > 0)
}

const searchParams = ref({})

const markClick = async (data) => {
  currentStockId.value = data.id
  searchParams.value = {...searchParams.value, stockId: currentStockId.value}
  currentData.value.stockName = data.stockName
  await queryList()
  showDrawer.value = true
}

const queryList = async () => {
  searchParams.value.exists = 1
  const {totalCount, records} = await stockApi.queryStockProduct(searchParams.value)
  currentData.value.productList = records
  searchParams.value.totalCount = totalCount
}

const tableRef = ref()

// 快速领用
const toReceipt = () => {
  const productList = tableRef.value.getSelectionRows()
  if (productList.length === 0) {
    proxy.$message.error("请选择要领用的商品")
    return
  }
  // 获取仓库id
  const data = {
    productIds: productList.map(item => item.skuId),
    stockId: currentStockId.value
  }
  proxy.$routerUtil.push(`/stock/requisite/detail?fastRequisite=${JSON.stringify(data)}`)
}

// 初始化时获取当前的经纬度进行定位、通过腾讯地图来进行获取定位经纬度
onMounted(async () => {
  // 创建腾讯地图 Geolocation 实例
  await initStockList();
  setTimeout(() => {
    commonApi.findSetting("MINI_MAP_KEY").then(setting => {
      apiKey.value = setting.settingValue
      showMap.value = true
    })
  }, 1000)
})

</script>

<style lang="scss" scoped>
@import "@/assets/css/el-tables";

.show-stock {
  position: absolute;
  z-index: 2000;
  padding: 7px 8px;
  background: white;
  right: 29px;
  top: 201px;
  box-shadow: 0 0 6px 1px #dddcdc;
  cursor: pointer;
}

.option-area {
  position: absolute;
  left: 10px;
  top: 10px;
  background: #FFF;
  padding: 10px;
  z-index: 2000;
  white-space: nowrap;
}

:deep(.el-drawer__header) {
  margin-bottom: 10px !important;
}

:deep(.is-current>.el-tree-node__content) {
  color: black !important;
}

:deep(.el-tree) {
  background: rgba(0,0,0, 0.3);
  color: white;
  font-size: 17px;
}

:deep(.el-tree-node__content) {
  padding: 8px 0 !important;
}

:deep(.el-tree-node>.el-tree-node__content):hover {
  color: black !important;
}
</style>